import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-68" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-69" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-grape" data-id="element-70" data-mp="32m1bayt2r0om">
          DER REHA-CODE 360°<span className="align-super text-xs" data-id="element-71" data-mp="36ppn5toqoifo">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-72" data-mp="3ug3fllb8kjas">
          Das klinische System zur Verwaltung der Verletzungsrehabilitation von Grund auf:
          Medizinische Beurteilung, progressive Trainings-Protokolle, Return-to-Sport-Frameworks
          und lebenslange Prävention in 30 Tagen.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-73" data-mp="3qfji2gmr3do4">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-74" data-mp="2a1jjpa3jzw2z">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-75" data-mp="3labp9pa6nun7" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-76" data-mp="3gbr0cm0dsxe2">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-77" data-mp="3v91a9qxdlv7o" /> @sigmasmart.deutsch
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-78" data-mp="3qazp90ge3ltk">
          🏥 „Dein erstes Protokoll startet heute."
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-79" data-mp="32w3duq73ebb">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-80" data-mp="hrs7xht1m976">
            Allgemeine Geschäftsbedingungen
          </a>
          <span data-id="element-81" data-mp="cw34v4htea64">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-82" data-mp="qt04nvfwv1z5">
            Datenschutzerklärung
          </a>
          <span data-id="element-83" data-mp="mt7vbgip0rsq">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-84" data-mp="mptqm1mk46i4">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-85" data-mp="ytoay73hgnzh">
          © 2026 DER REHA-CODE 360° — SIGMA SMART™ — Alle Rechte vorbehalten. Vervielfältigung und
          Weiterverbreitung ohne ausdrückliche Genehmigung untersagt.
        </p>
      </div>
    </footer>;
}